/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { isBrowser } from 'common/constants/config';
import { FRONT_CRASH, FRONT_WARN } from 'common/constants/service-errors';
import { t } from 'common-translation/tools';
import React, { Fragment } from 'react';

import logger from '../../helpers/logger';
import DocProductRender from './DocProductRender';
// import { reportPlus } from '../../helpers/report';
import { getErrorPageContent } from './ErrorPageContent';

const styles = `
body { min-height: auto }
`;


function getAndClearNotFoundCookie() {
  if (!isBrowser) return null;

  function parseCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';')
      .shift());
    return null;
  }

  const cookieData = parseCookie('lastNotFoundDataDoc');
  if (!cookieData) return null;

  try {
    const parsed = JSON.parse(cookieData);
    // 立即清除
    document.cookie = 'lastNotFoundDataDoc=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
    return parsed;
  } catch (e) {
    console.error('解析 lastNotFoundDataDoc Cookie 失败', e);
    return null;
  }
}


export default class ErrorPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      cookieData: null,
      loading: true,
    };
  }
  componentDidMount() {
    if (window) {
      window.onload = () => {
        // 单独上报数据至大同
        if (window.recordBehavior?.reportEvent && location.search.includes('from_cn_redirect=1')) {
          const pathName = location.pathname;
          const ids = pathName.includes('/document/api') ? pathName.split('/document/api')[1] : pathName.split('/document/product')[1];
          const idData = ids && ids.split('/');
          window.recordBehavior.reportEvent(
            'document_fromCN_404',
            {
              ext1: document.referrer,  // 来源
              ext2: (idData && idData[1]) || '', // 类目id
              ext3: (idData && idData[2]) || '', // 产品id
            },
          );
        }
      };
    }
    const data = getAndClearNotFoundCookie();
    this.setState({ cookieData: data || null, loading: false }); // 关键改动
  }
  render() {
    const {
      code,
      backUrl,
      backBtnMsg,
      err } = this.props; // msg, detail, notHitRoute,

    const { cookieData, loading } = this.state;

    const reqId = err?.reqId;
    const traceId = err?.traceId;
    const ErrorPageContent = getErrorPageContent(code);

    if (isBrowser) {
      // 上报数据前端报错数据
      // reportPlus({
      //   name: 'front_error',
      //   jKey: { eType: 'error', code },
      //   jValue: { num: 1 },
      //   jData: { reqId },
      // });

      // TAM上报错误
      if (window && window.globalAegis) {
        const level = code === 500 ? FRONT_CRASH : FRONT_WARN;
        window.globalAegis.error({
          front_error: {
            reqId,
            traceId,
            code,
            level,
          },
        });
      }
    } else {
      if (code !== '404') {
        logger.error('Error', { code, ...err });
      }
    }

    function submitTicket() {
      location.href = '/login?s_url=https%3A%2F%2Fconsole.cloud.tencent.com%2Fworkorder';
    }

    function goToHome() {
      location.href = backUrl || '/';
    }

    return [
      <style key="style" dangerouslySetInnerHTML={{ __html: styles }} />,
      <Fragment key="box">
        {
          !loading && cookieData
            ? <DocProductRender icon={ErrorPageContent.icon} redirectUrl={cookieData.redirectUrl} redirectTitle={cookieData.redirectTitle} />
            : loading ? <div>{t('Loading')}...</div> :  <div className="com-none-panel page">
              <div className="com-none-panel-object">
                <i className={`com-none-panel-icon ${ErrorPageContent.icon}`} />
              </div>
              <div className="com-none-panel-main">
                <h3 className="com-none-panel-title">{ErrorPageContent.title}</h3>
                <div className="com-none-panel-desc">
                  <p>
                    {ErrorPageContent.desc}
                    {reqId && ` ( REQ_ID: ${reqId} ) `}
                    {traceId && ` ( TRACE_ID: ${traceId} ) `}
                  </p>
                </div>
                <div className="com-none-panel-btns">
                  <button className="c-btn " onClick={submitTicket}>
                    <span className="text">{t('Submit Ticket')}</span>
                  </button>
                  <button className="c-btn c-btn-hole" onClick={() => goToHome(backUrl)}>
                    <span className="text">{backBtnMsg || t('Go to Home Page')}</span>
                  </button>
                </div>
              </div>
            </div>
        }
      </Fragment>,
    ];
  }
}
